import { render, staticRenderFns } from "./AppInfoTip.vue?vue&type=template&id=a883c7aa&scoped=true&"
import script from "./AppInfoTip.vue?vue&type=script&lang=js&"
export * from "./AppInfoTip.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoTip.vue?vue&type=style&index=0&id=a883c7aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a883c7aa",
  null
  
)

export default component.exports